









































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { unifiedMessageContainer } from '../../shared/constants';
import { SwMessageContainer } from '@libs-uuif/shared/message-service';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import { CoreStoreState } from '../core.store';

const cssPrefix = 'sw-app-content';
@Component({
  components: { SwMessageContainer },
})
export default class SwAppContent extends SwExtendedVue {
  @State((state: RootStoreState) => state.CoreStoreModule.selectedNavItemId)
  selectedNavItemId: CoreStoreState['selectedNavItemId'];
  cssPrefix = cssPrefix;
  autoHide: boolean = true;
  unifiedMessageContainer: string = unifiedMessageContainer;
}
